require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/es6.array.species.js
// module id = 2165
// module chunks = 3